export default "__VITE_ASSET__e26952ab__"